export const ClassNames = {
    ListItem: 'list-item',
    ListItemActions: 'list-item-actions',
    ListHeader: 'list-header',
};
